import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import SearchView from "../../../widgets/SearchView";
import MunicipalitySearchForm from './MunicipalitySearchForm';
import { ViewContainer } from "./../../../View.jsx";
import CardLayout from '../../../widgets/Card';
import ViewUtils from '../../../ViewUtils';

const utils = new ViewUtils();

const headCells = [
    { id: "MunicipalityName", numeric: false, disablePadding: true, label: "Municipality Name" },
    { id: "CityName", numeric: false, disablePadding: true, label: "City Name" },
    { id: "PostalCode", numeric: false, disablePadding: true, label: "Postal Code" }
]

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'info', label: '', tooltip: 'Select Municipality from the table and click save to add', icon: 'InfoIcon' }
            ]
        }
    ]
}

class MunicipalitySearch extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = 
            [
                { Name: "MunicipalityName", Value: "" },
                { Name: "CityName", Value: "" },
                { Name: "PostalCode", Value: "" }
            ]
            

        this.state = {
            model: {
                MunicipalityName: "",
                CityName: "",
                PostalCode: ""
            },
            keyUpSwitch: false,
            selectedMunicipality: null,
            linkDialogOpen: false
        }
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={this.props.showTitle === true || utils.isNull(this.props.showTitle) ? 'Municipality' : null}>
                <SearchView
                    config={toolbarConfig}
                    mode={this.props.mode}
                    headCells={headCells}
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/indicium/OFOOccupation/search"}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="MunicipalityName" 
                    model={this.state.model}
                    searchParameters={this.searchParameters}
                    keyUpSwitch={this.state.keyUpSwitch}
                >
                    <MunicipalitySearchForm onKeyUp={(e) => { this.onkeyup(e) }} model={this.state.model} />
                </SearchView>
            </ViewContainer>
            )
    }
}

export default withRouter(
    connect()(MunicipalitySearch)
);